import React, {  useState } from 'react'
import { connect } from 'react-redux'
import Checkbox from '../common/Checkbox'
import Style from 'style-it'
import SearchField from '../common/SearchField'
import { withTranslationWrapper } from '../../HOC';
import Scrollbar from 'react-scrollbars-custom'
import { fetchMoreDevices } from '../../Actions/Devices'
import InfiniteScroll from 'react-infinite-scroll-component'
import Loader from '../../Layout/Loader'
// class BinderSelector extends Component {
  const BinderSelector = (props) => {

    const [state, setState] = useState({
      list: {},
      others: [],
      search: '',
      isChecked: false 
    })
  // constructor (props) {
  //   super(props)
  //   state = {
  //     list: {},
  //     others: [],
  //     search: '',
  //     isChecked: false
  //   }
  // }


  useEffect(() => {
    const list = {}
    const others = []
    if (props.value && props.value.length && props.trailers && props.trailers.length) {
      props.value.map(d => {
        const found = props.trailers.find(dev => dev.id === parseInt(d));
        if(found) {
          list[d] = true
        }
        else {
          others.push(d)
        }
        return null
      })
    }
    setState((prevState)=>({ ...prevState,list, others }))
  }, [])
  
  // componentWillMount () {
  //   const list = {}
  //   const others = []
  //   if (props.value && props.value.length && props.trailers && props.trailers.length) {
  //     props.value.map(d => {
  //       const found = props.trailers.find(dev => dev.id === parseInt(d));
  //       if(found) {
  //         list[d] = true
  //       }
  //       else {
  //         others.push(d)
  //       }
  //       return null
  //     })
  //   }
  //   setState({ list, others })
  // }


  useEffect(() => {
    const list = {}
    const others = []
    if (nextprops.value && nextprops.value.length && nextprops.trailers && nextprops.trailers.length) {
      nextprops.value.map(d => {
        const found = nextprops.trailers.find(dev => dev.id === parseInt(d));
        if(found) {
          list[d] = true
        }
        else {
          others.push(d)
        }
        return null
      })
    }
    setState((prevState)=>({ ...prevState,list, others }))

  }, [nextprops.value,nextprops.trailers ])
  
  // componentWillReceiveProps (nextprops) {
  //   const list = {}
  //   const others = []
  //   if (nextprops.value && nextprops.value.length && nextprops.trailers && nextprops.trailers.length) {
  //     nextprops.value.map(d => {
  //       const found = nextprops.trailers.find(dev => dev.id === parseInt(d));
  //       if(found) {
  //         list[d] = true
  //       }
  //       else {
  //         others.push(d)
  //       }
  //       return null
  //     })
  //   }

  //   setState({ list, others })

  // }


   const sendToParent = () =>{
    if (props.onChange) {
      props.onChange([...Object.keys(state.list), ...state.others])
    }
  }
  const  onChange = (e, v) => {
    let list = { ...state.list }
    if (e.target.checked) {
      list[v.id] = true
    } else {
      delete list[v.id]
    }
    setState((prevState)=>({
      ...prevState,
      list,
      isChecked: props.trailers.length === Object.keys(list).length
    }))
    sendToParent();
    // setState(
    //   {
    //     list,
    //     isChecked: props.trailers.length === Object.keys(list).length
    //   },
    //   () => {
    //     sendToParent()
    //   }
    // )
  }

   const searchItem = text => {
    setState((prevState)=>({
      ...prevState,
      search: text.target.value
    }))
    // setState({ search: text.target.value }, () => {
    // //   props.dispatch(searchDevices({ device: state.search }))
    // })
  }

   const toggleItems = event => {
    if (event.target.checked) {
      let list = {}
      let items = []
      if (state.search) {
        items = props.trailers.data
      } else {
        items = props.trailers
      }
      items.map(d => (list[d.id] = true))
      // setState({ list, isChecked: true }, () => {
      //   sendToParent()
      // })
      setState((prevState)=>({
        ...prevState,
        list,
         isChecked: true 
      }))
      sendToParent();
    } else {
      setState((prevState)=>({
        ...prevState,
        list: {}, 
         isChecked: false 
      }))
      sendToParent();
      // setState({ list: {}, isChecked: false }, () => {
      //   sendToParent()
      // })
    }
  }

  // render () {
    const endMessage =
      props.trailers && props.trailers.length > 0 ? (
        <p style={{ textAlign: 'center', color: '#ccc' }}>
          {' '}
          -- {props.translate('end')} --{' '}
        </p>
      ) : (
        <p style={{ textAlign: 'center', color: '#ccc' }}>
          {' '}
          {props.translate('notFound')}{' '}
        </p>
      )
    return (
      <Style>
        {`
        .selector-list li > label.active,
        .selector-list li > label:hover {
            background: ${props.themecolors&&props.themecolors.themeLightColor};
            color: ${props.themecolors&&props.themecolors.themeLightInverse};
        }
        .selector-list li {
            margin-bottom: 6px
        }
        .selector-list li > label {
            cursor: pointer;
            display: block;
            padding: 2px 6px;
            border-radius: 4px;
            display: flex;
            align-items: center;
            background: ${props.themecolors.themeListingColor};
          }
          .selector-list {
            padding: 0;
            margin: 0;
            color: ${props.themecolors.themeListingInverse};
            list-style: none
          }
          .selector-label {
            font-size: 12px;
            line-height: 1.5;
            margin-left: 6px;
        }
        .selector-image {
            width: 26px;
            margin-left: 6px;
        }
        .selector-image img {
            height: auto;
            width: 26px;
            height: 26px;
            display: block;
            margin: auto;
        }
        .selector-count {
            padding: 0 0 6px;
            font-size: 10px;
            display: flex;
            justify-content: space-between
        }`}
        <div style={{ width: '100%' }}>
          <div
            className='section-head clearfix section-head-filter'
            style={{ padding: 0, marginLeft: -6, marginRight: -2 }}
          >
            <ul className='filter-row pull-left'>
              <li>
                <SearchField
                  label={props.translate('searchBinders')}
                  type='search'
                  placeholder='exp: ID, Name'
                  value={state.search}
                  onChange={searchItem}
                  variant='outlined'
                  margin='dense'
                  fullWidth
                />
              </li>
              {!props.readOnly ? (
                <li style={{ paddingRight: 0, paddingTop: 3 }}>
                  <Checkbox
                    checked={state.isChecked}
                    onChange={toggleItems}
                    label={props.translate('selectAll')}
                  />
                </li>
              ) : null}
            </ul>
          </div>
          {!props.readOnly ? (
            <div className='selector-count'>
              <span><span style={{marginRight: 3}}>{Object.keys(state.list).length}</span>
              {props.translate('binderSelected')}</span>
            </div>
          ) : null}
          <Scrollbar
            disableTracksWidthCompensation={true}
            style={{
              height: 32 * (props.rows || 10)
            }}
            scrollerProps={{
              renderer: props => {
                const { elementRef, ...restProps } = props
                return (
                  <div
                    {...restProps}
                    ref={elementRef}
                    id='scrollableBinderSelector'
                  />
                )
              }
            }}
          >
            {props.trailers ? (
              <InfiniteScroll
                dataLength={props.trailers.length}
                next={() => props.dispatch(fetchMoreDevices())}
                hasMore={props.trailers.hasNext}
                loader={<Loader defaultStyle={true} />}
                scrollableTarget='scrollableBinderSelector'
                endMessage={endMessage}
              >
                <ul className='selector-list'>
                  {props.trailers.map(row => (
                    <li key={row.id}>
                      <label
                        className={state.list[row.id] ? 'active' : null}
                      >
                        {!props.readOnly ? (
                          <span className='selector-check'>
                            <Checkbox
                              checked={state.list[row.id]}
                              value={row}
                              onChange={onChange}
                            />
                          </span>
                        ) : null}
                        {props.hideIcons ? null : (
                          <span className='selector-image'>
                            <img
                              src={
                                '/assets/category/default/' +
                                (row.category || 'default') +
                                '.svg'
                              }
                              // alt={row.name}
                            />
                          </span>
                        )}
                        <span className='selector-label'>{row.name}</span>
                      </label>
                    </li>
                  ))}
                </ul>
              </InfiniteScroll>
            ) : props.trailers.hasNext ||
              props.trailers.isFetching ? (
              <Loader defaultStyle={true} />
            ) : null}
          </Scrollbar>
        </div>
      </Style>
    )
  // }
}

const mapState = state => ({
  trailers: state.trailers,
  themecolors: state.themeColors
})
const mapStateToProps = connect(mapState)
export default mapStateToProps(withTranslationWrapper(BinderSelector))
